import { COLORS } from "../../../../utils/constant";

const activityNameMap = {
    email: "Email",
    chat: "Chat",
    adhoc: "Adhoc",
    expert_access: "Expert Access",
    corporate_access: "Corporate Access",
    client_meeting: "Client Meeting",
    bespoke_work: "Bespoke",
    conference: "Conference",
};

export const transformChartData = (data) => {
    // Filter out activities with zero values for all analysts
    return data
        .map((item) => {
            const transformedItem = {
                activityType:
                    activityNameMap[item.name] || formatActivityName(item.name),
            };

            Object.entries(item).forEach(([key, value]) => {
                if (key !== "name" && key !== "user") {
                    transformedItem[key] = value;
                }
            });

            return transformedItem;
        })
        .filter((item) => {
            // Check if at least one analyst has a non-zero value
            const values = Object.values(item).filter(
                (val) => typeof val === "number"
            );
            return values.some((val) => val > 0);
        });
};

export const formatActivityName = (name) => {
    return name
        .split("_")
        .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
};

export const getAnalysts = (data) => {
    if (!data || data.length === 0) {
        return [];
    }
    return Object.keys(data[0]).filter(
        (key) => key !== "name" && key !== "user"
    );
};

export const getColors = (count) => {
    return Array(Math.ceil(count / COLORS.length))
        .fill(COLORS)
        .flat()
        .slice(0, count);
};

export const transformDataByName = (data) => {
    const result = {};

    data.forEach((item) => {
        const userName = item.user || "Unknown";

        // If the user doesn't exist in the result, initialize it
        if (!result[userName]) {
            result[userName] = { name: userName };
        }

        // Sum up all relevant keys
        Object.keys(item).forEach((key) => {
            if (key !== "user" && key !== "client" && key !== "total") {
                result[userName][key] =
                    (result[userName][key] || 0) + item[key];
            }
        });
    });

    // Return an array of the aggregated objects
    return Object.values(result);
};

export const transformDataByMetric = (data) => {
    // Check if data is undefined, null, or empty
    if (!data || data.length === 0) {
        return [];
    }

    // Get all possible metrics (exclude certain keys)
    const excludedKeys = ["client", "user", "total"];
    const metrics = Object.keys(data[0]).filter(
        (key) => !excludedKeys.includes(key)
    );

    // Initialize the result array
    const result = metrics.map((metric) => {
        const metricObj = { name: metric };

        // Add values for each user
        data.forEach((item) => {
            const userName = item?.user || "Unknown";
            metricObj[userName] =
                (metricObj[userName] || 0) + (item?.[metric] || 0);
        });

        return metricObj;
    });

    return result;
};
